import type { Deck, ExamId } from "./types";
import { corpusLabel } from "../data/corpus";
import { EXAM_PROFILES } from "../data/exam-profiles";
import { WORDS } from "../data/words";

const starterDeckName = (exam: ExamId) => corpusLabel(EXAM_PROFILES[exam].label);

export const DEFAULT_STARTER_DEADLINE = "2027-04-08";
export const DEFAULT_STARTER_DEADLINE_LABEL = "DSE 2027 考期";

interface StarterDeckInput {
  exam: ExamId;
  wordIds: string[];
  dailyNew: number;
  now: string;
  deadline?: string;
  deadlineLabel?: string;
}

export function createStarterDeck({ exam, wordIds, dailyNew, now, deadline, deadlineLabel }: StarterDeckInput): Deck {
  return {
    id: `starter-${exam}-${now.slice(0, 10)}`,
    name: starterDeckName(exam),
    exam,
    wordIds,
    dailyNew,
    deadline,
    deadlineLabel,
    createdAt: now,
    updatedAt: now,
  };
}

export function createDefaultHkdseDeck(now = new Date().toISOString()): Deck {
  return createStarterDeck({
    exam: "hkdse",
    wordIds: WORDS.map((w) => w.id),
    dailyNew: 20,
    now,
    deadline: DEFAULT_STARTER_DEADLINE,
    deadlineLabel: DEFAULT_STARTER_DEADLINE_LABEL,
  });
}

